/** Account + security. Field labels: ui/common.js. */
const dictionary = {
  "en": {
    "saveChanges": "Save changes",
    "hideCandidateNames": "Hide Candidates/Team Members name",
    "changePassword": "Change Password",
    "nav": {
      "account": "Account",
      "security": "Security"
    },
    "deleteAccount": "If you wish to delete your account, send us a request to delete or deactivate your account in Help Center by filling out the form, or contacting us via email info@apexteam.ai. Please note that after deletion, all your data and information will be lost and cannot be recovered.",
    "toasts": {
      "updatingAccount": "Updating account details...",
      "accountUpdated": "Account details updated",
      "accountUpdateError": "Unable to change account details. Please contact our support",
      "updatingCompany": "Updating company details...",
      "companyUpdated": "Company details updated",
      "companyUpdateError": "Unable to change company details. Please contact our support",
      "passwordUpdated": "Password updated successfully",
      "invalidValues": "Invalid values provided. Please try again. Or contact our support"
    }
  },
  "de": {
    "saveChanges": "Änderungen speichern",
    "hideCandidateNames": "Namen von Kandidat:innen/Teammitgliedern ausblenden",
    "changePassword": "Passwort ändern",
    "nav": {
      "account": "Konto",
      "security": "Sicherheit"
    },
    "deleteAccount": "Wenn Sie Ihr Konto löschen möchten, senden Sie uns im Hilfezentrum über das Formular eine Anfrage zur Löschung oder Deaktivierung, oder kontaktieren Sie uns per E-Mail unter info@apexteam.ai. Bitte beachten Sie, dass nach der Löschung alle Ihre Daten und Informationen verloren gehen und nicht wiederhergestellt werden können.",
    "toasts": {
      "updatingAccount": "Kontodaten werden aktualisiert...",
      "accountUpdated": "Kontodaten aktualisiert",
      "accountUpdateError": "Kontodaten konnten nicht geändert werden. Bitte kontaktieren Sie unseren Support",
      "updatingCompany": "Unternehmensdaten werden aktualisiert...",
      "companyUpdated": "Unternehmensdaten aktualisiert",
      "companyUpdateError": "Unternehmensdaten konnten nicht geändert werden. Bitte kontaktieren Sie unseren Support",
      "passwordUpdated": "Passwort erfolgreich aktualisiert",
      "invalidValues": "Ungültige Werte. Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Support"
    }
  },
  "fi": {
    "saveChanges": "Tallenna muutokset",
    "hideCandidateNames": "Piilota hakijoiden ja tiimin jäsenten nimet",
    "changePassword": "Vaihda salasana",
    "nav": {
      "account": "Tili",
      "security": "Tietoturva"
    },
    "deleteAccount": "Jos haluat poistaa tilisi, lähetä meille pyyntö tilin poistamisesta tai sulkemisesta täyttämällä lomake Ohjekeskuksessa tai ottamalla yhteyttä sähköpostitse osoitteeseen info@apexteam.ai. Huomaa, että poistamisen jälkeen kaikki tietosi menetetään eikä niitä voi palauttaa.",
    "toasts": {
      "updatingAccount": "Päivitetään tilin tietoja...",
      "accountUpdated": "Tilin tiedot päivitetty",
      "accountUpdateError": "Tilin tietoja ei voitu muuttaa. Ota yhteyttä tukeemme",
      "updatingCompany": "Päivitetään yrityksen tietoja...",
      "companyUpdated": "Yrityksen tiedot päivitetty",
      "companyUpdateError": "Yrityksen tietoja ei voitu muuttaa. Ota yhteyttä tukeemme",
      "passwordUpdated": "Salasana päivitetty",
      "invalidValues": "Annetut arvot ovat virheellisiä. Yritä uudelleen tai ota yhteyttä tukeemme"
    }
  }
};

export default dictionary;
